import Radio from "backbone.radio";
import { Backbone } from "extensions/backbone";

import { references } from "common/helpers/references";
import { Qualifiers } from "../qualifiers";

export const Filter = Backbone.Model.extend({
    idAttribute: "_id",
    defaults: {
        qualifiers: "",
        name: ""
    },
    
    getQualifiersGroup(operator) {
        const q = new Qualifiers({
            
            value: this.get("qualifiers")
        });
    
        return q.value.reduce((memo, c) => {
            const namePlural = Radio.channel("main").request("get:getters").findPivotName(c.category, { plural: true });
            
            memo[namePlural] = c.values.reduce((acc, v) => {
                if (v.operator === operator) {
                    acc.push(references.toAlias(v.value, c.category));
                }
                return acc;
            }, []);
            
            if (!memo[namePlural].length) {
                delete memo[namePlural];
            }
            
            return memo;
        }, {});
    },
    
    getIncludedQualifiers() {
        return this.getQualifiersGroup("=");
    },
    
    getExcludedQualifiers() {
        return this.getQualifiersGroup("!=");
    }
});
